import { render, staticRenderFns } from "./SearchPlagin.vue?vue&type=template&id=2191823e&scoped=true&"
import script from "./SearchPlagin.vue?vue&type=script&lang=js&"
export * from "./SearchPlagin.vue?vue&type=script&lang=js&"
import style0 from "./SearchPlagin.vue?vue&type=style&index=0&id=2191823e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2191823e",
  null
  
)

export default component.exports